angular.module('dpw.components').component('dpwAppIcon', {
    bindings: {
        application: '<',
        required: '<'
    },
    templateUrl: 'dpw-app-icon.html',
    controllerAs: 'ctrl',
    controller: ['api', 'appIconService', '$scope', 'applicationService', function (api, appIconService, $scope, applicationService) {
        var self = this;

        var isSupportSvg = true;

        self.errorMessage = null;

        self.placeholder = appIconService.placeholder;

        self.$onInit = function () {
            updateIsSupportSvg();
            self.file = self.application.newIcon || self.application.iconUrl;
        };

        $scope.$watch('ctrl.application.type', function () {
            updateIsSupportSvg();
            recheckNewIconIsValid();
        });

        self.choose = function (file) {
            if (file === null) {
                return;
            }

            appIconService.isValid(file, isSupportSvg)
                .then(function () {
                    updateIconConfig(file);
                })
                .catch(function (errorType) {
                    updateIconConfig(null, errorType);
                });
        };

        self.remove = function () {
            self.file = null;
            self.application.iconUrl = null;
            self.application.newIcon = null;
        };

        self.getIconFormatDesc = function () {
            if (isSupportSvg) {
                return 'File format supported: jpg, png, svg or gif';
            }
            return 'File format supported: jpg, png or gif';
        };

        self.getValidImageMimeTypes = function () {
            return appIconService.getValidImageMimeType(isSupportSvg);
        };

        function updateIconConfig(file, errorType) {
            self.file = file;
            self.application.invalidIcon = !file;
            self.errorMessage = file ? null : appIconService.errorMessageMapping[errorType];
            self.application.newIcon = file;
        }

        function updateIsSupportSvg() {
            isSupportSvg = !applicationService.isBotApp(self.application);
        }

        function recheckNewIconIsValid() {
            if (!self.application.newIcon) {
                clearInvalidStatus();
                return;
            }
            self.choose(self.application.newIcon);
        }

        function clearInvalidStatus() {
            if (!self.application.invalidIcon) {
                return;
            }
            self.application.invalidIcon = false;
            self.errorMessage = null;
        }
    }]
});
